/* eslint-disable no-useless-escape */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import groupBy from 'array.prototype.groupby';
import axios from 'axios';
import './SecondPresidential.scss';
import useDimension from '../../hooks/useDimension';
import PresiResume from '../../components/PresiResume/PresiResume';
import JSONSecondPresident from '../../utils/JSONSecondPresident';
import PresiCardSecond from '../../components/PresiCardSecond';

const SecondPresidential = () => {
  const [searchParams] = useSearchParams();
  const typeData = searchParams.get('data');
  const paramElecciones = searchParams.get('elecciones');
  const paramsCandidatos = searchParams.get('candidatos');
  const URL_manual = `https://data-ecp.infobae.com/infobae.com/2022/colombia/segunda%20vuelta/CO_president.json?timestamp=${new Date().getTime()}`;
  const URL_auto = `https://d3ahrew49i7mgf.cloudfront.net/resultadosGeneralesSegundaVuelta.json?timestamp=${new Date().getTime()}`;
  const FETCH_URLS = {
    manual: URL_manual,
    auto: URL_auto,
  };
  const currentUrl = FETCH_URLS[typeData] || null;
  const elecciones = paramElecciones === 'false' ? false : true;
  const candidatos = paramsCandidatos === 'false' ? false : true;

  groupBy.shim();
  const [info, setInfo] = useState([]);
  const [isMobile, setIsMobile] = useState(false);
  const [votes, setVotes] = useState({
    votesTotal: 0,
    votesAnnulled: 0,
    votesBlank: 0,
    votesInvalid: 0,
  });

  const numberFormat = (number) => number.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.');
  const formatedJSONData = (data) =>
    data.map((e) => ({
      ...e,
      color: e?.settings?.color || '#000000',
      votes: numberFormat(e?.votes || 0.0),
      votes_percent: parseFloat(e?.votes_percent || 0.0),
      candidates: e.candidates.sort(function (a, b) {
        if (a.candidate_id > b.candidate_id) return 1;
        if (a.candidate_id < b.candidate_id) return -1;
        return 0;
      }),
    }));

  const getData = async () => {
    try {
      let resp = await axios.get(currentUrl);
      let missingParties = resp.data.parties;
      if (missingParties.length < JSONSecondPresident.parties.length) {
        // agrega cards de partidos faltantes
        missingParties = JSONSecondPresident.parties.map((party) => {
          if (missingParties.find((p) => p.party_id === party.party_id)) {
            return missingParties.find((p) => p.party_id === party.party_id);
          }
          return party;
        });

        // vuelve a ordenar por mayor numero de votos
        missingParties = missingParties.sort(function (a, b) {
          if (a.votes < b.votes) return 1;
          if (a.votes > b.votes) return -1;
          return 0;
        });
      }

      let formatedData = formatedJSONData(missingParties);

      setInfo(formatedData);
      setVotes({
        votesTotal: numberFormat(resp.data.election.total_votes.qty || 0.0),
        votesAnnulled: numberFormat(resp.data.stats.find((e) => e.type === 'annulled').votes || 0.0),
        votesBlank: numberFormat(resp.data.stats.find((e) => e.type === 'blank').votes || 0.0),
        votesInvalid: resp.data.election.tables.percent.toFixed(2).toString().replace('.', ',') || 0.0,
      });
    } catch (error) {
      let formatedDataError = formatedJSONData(JSONSecondPresident.parties);
      setInfo(formatedDataError);
      console.log(error);
    }
  };

  useDimension(setIsMobile, 300);

  useEffect(() => {
    getData();
  }, []);

  return (
    <div className="p-container-second">
      {candidatos ? (
        <div className={`p-container-second__cards`}>
          {info.map((coal) => (
            <div key={coal.name} className="p-container-second__card">
              <PresiCardSecond party={coal} isMobile={isMobile} />
            </div>
          ))}
        </div>
      ) : (
        ''
      )}
      {elecciones ? <PresiResume votes={votes} /> : ''}
    </div>
  );
};

export default SecondPresidential;
